import React, { useMemo, useState, useEffect } from 'react';
import { ZnesekInput } from './ZnesekInput'; // [PATCH ddv-vnos v1] draft vnos zneskov (Excel-stil)
import { jeIzdaniTip } from '../utils/docSmer';  // [PATCH izdani-doctype-fe v2]
import { kontoZaVrsto } from '../lib/ddvKonto'; // [PATCH ddv-konto-lib v1] en vir resnice
import { api } from '../lib/api'; // [PATCH oss-temelji v1] sifranti OSS (drzave, stopnje, konti)

const fmt = (n: number) => { const x = Number(n||0).toFixed(2); const [c, d] = x.split('.'); return c.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d; }; // [PATCH stevilke-locila v1] tisociska pika
const fmt3 = (n: number) => { const x = Number(n||0).toFixed(2); const [c, d] = x.split('.'); return c.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d; }; // [PATCH stevilke-locila v1] identicno fmt; klicna mesta nedotaknjena

export const VRSTE_DDV = [
  // Domači DDV - P8
  { value: 'DOM_22', label: 'DDV 22%', p: 'P8', stopnja: 22, odbitno: true, vasco: 'ddv_visja_vstopni', opis: 'Domači DDV 22% - odbitni' },
  { value: 'DOM_95', label: 'DDV 9,5%', p: 'P8', stopnja: 9.5, odbitno: true, vasco: 'ddv_nizja_vstopni', opis: 'Domači DDV 9,5% - odbitni' },
  { value: 'DOM_5', label: 'DDV 5%', p: 'P8', stopnja: 5, odbitno: true, vasco: 'ddv_posebna_nizja_vstopni', opis: 'Domači DDV 5% - odbitni' },
  // Neobdavčen promet s pravico do odbitka - P8
  { value: 'NEOBDAVCEN', label: 'Neobdavčen (pravica odbitka)', p: 'P8', stopnja: 0, odbitno: true, vasco: 'neobdavcen_promet_s_pravico_do_odbitka', opis: 'Neobdavčen promet s pravico do odbitka DDV' },
  { value: 'NI_PREDMET', label: 'Ni predmet DDV (ne gre v knjigo)', p: '', stopnja: 0, odbitno: false, vasco: 'ne_gre_v_knjigo', opis: 'Ni promet po ZDDV-1 (dajatve, takse, rezervni sklad) - se ne evidentira v DDV knjigi' },
  // DDV ki se ne odbija - P17
  { value: 'DOM_NEODB', label: 'DDV - ne odbija (P17)', p: 'P17', stopnja: 22, odbitno: false, vasco: 'ddv_visja_vstopni_ne_odbija', opis: 'DDV ki se ne odbija' },
  // Samoobdavčitev 76.a člen - P9
  { value: '76A', label: '76.a člen (P9)', p: 'P9', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_vstopni_76a', opis: 'Samoobdavčitev po 76.a členu' },
  // Samoobdavčitev 76.a - obračunani KIR + vstopni KPR (zrcalno EU)
  { value: '76A_KIR', label: '76.a obračunani KIR (P18)', p: 'P18', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_obracunan_76a', opis: 'Obračunani DDV 76.a - KIR P18' },
  { value: '76A_KPR', label: '76.a vstopni KPR (P9)', p: 'P9', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_vstopni_76a', opis: 'Vstopni DDV 76.a - KPR P9' },
  // Pridobitve blaga znotraj EU - P10
  { value: 'EU_BLAGO', label: 'Pridobitev blaga EU (P10)', p: 'P10', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_vstopni', opis: 'Pridobitve blaga znotraj skupnosti' },
  // Prejete storitve iz EU - P11
  { value: 'EU_STOR', label: 'Storitve EU (P11)', p: 'P11', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_vstopni', opis: 'Obdavčene prejete storitve iz EU' },
  { value: 'EU_STOR_KIR', label: 'Storitve EU obračunani KIR (P18)', p: 'P18', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_obracunani', opis: 'Obračunani DDV EU storitve - KIR P18' },
  { value: 'EU_STOR_KPR', label: 'Storitve EU vstopni KPR (P11/P18)', p: 'P11', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_vstopni', opis: 'Vstopni DDV EU storitve - KPR P11/P18' },
  { value: 'EU_BLAGO_KIR', label: 'Blago EU obračunani KIR (P18)', p: 'P18', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_obracunani_blago', opis: 'Obračunani DDV EU blago - KIR P18' },
  { value: 'EU_BLAGO_KPR', label: 'Blago EU vstopni KPR (P10/P18)', p: 'P10', stopnja: 22, odbitno: true, vasco: 'samoobdavcitev_visja_vstopni_blago', opis: 'Vstopni DDV EU blago - KPR P10/P18' },
  // Nepremičnine - P12
  { value: 'NEPREMICNINE', label: 'Nepremičnine (P12)', p: 'P12', stopnja: 22, odbitno: true, vasco: 'ddv_visja_vstopni', opis: 'Obdavčene nabave nepremičnin' },
  // Druga osnovna sredstva - P13
  { value: 'OS_DRUGO', label: 'Drugi OS (P13)', p: 'P13', stopnja: 22, odbitno: true, vasco: 'ddv_visja_vstopni', opis: 'Obdavčene nabave drugih osnovnih sredstev' },
  // Oproščene nabave - P14
  { value: 'OPROSCEN', label: 'Oproščeno (P14)', p: 'P14', stopnja: 0, odbitno: false, vasco: 'oproscen_promet_brez_pravice_do_odbitka', opis: 'Oproščene nabave in pridobitve (brez DDV)' },
  // Oproščene nabave nepremičnin - P15
  { value: 'OPROSCEN_NEPREM', label: 'Oproščeno nepremičnine (P15)', p: 'P15', stopnja: 0, odbitno: false, vasco: 'oproscen_promet_brez_pravice_do_odbitka', opis: 'Oproščene nabave nepremičnin' },
  // Oproščene nabave OS - P16
  { value: 'OPROSCEN_OS', label: 'Oproščeno drugi OS (P16)', p: 'P16', stopnja: 0, odbitno: false, vasco: 'oproscen_promet_brez_pravice_do_odbitka', opis: 'Oproščene nabave drugih OS' },
  // Uvoz
  { value: 'UVOZ', label: 'Uvoz', p: 'P8', stopnja: 22, odbitno: true, vasco: 'ddv_visja_vstopni', opis: 'Uvoz blaga iz tretjih držav' },
  // [PATCH ir3b-kontiranje v1] IZSTOPNE vrste (izdani računi — KIR)
  // [PATCH kir-labeli-brez-izdani v1] predpona odstranjena iz labelov; value/opis nedotaknjena
  /* [PATCH vod-vrste-oproscene v1] p je odslej KIR stolpec (P7..P27), ne polje
     starega obrazca DDV-O. Vir: KIR_KPR.xlsx, list 02-KIR (27.08.2026).
     Znesek DDV gre v P14/P15/P16 po stopnji -- izpelje se ob gradnji evidence. */
  { value: 'IZD_22', label: 'DDV 22%', p: 'P7', stopnja: 22, odbitno: true, vasco: 'izdani_visja', opis: 'Obdavčen promet 22% (izdani)' },
  { value: 'IZD_95', label: 'DDV 9,5%', p: 'P7', stopnja: 9.5, odbitno: true, vasco: 'izdani_nizja', opis: 'Obdavčen promet 9,5% (izdani)' },
  { value: 'IZD_5', label: 'DDV 5%', p: 'P7', stopnja: 5, odbitno: true, vasco: 'izdani_posebna', opis: 'Obdavčen promet 5% (izdani)' },
  { value: 'IZD_OPROSCEN', label: 'Oproščeno', p: 'P9', stopnja: 0, odbitno: false, vasco: 'izdani_oproscen', opis: 'Oproščen promet brez pravice do odbitka (izdani)' },
  { value: 'IZD_EU_OPROSCEN', label: 'Dobave blaga EU (46. člen)', p: 'P10', stopnja: 0, odbitno: false, vasco: 'izdani_eu_oproscen', opis: 'Oproščene dobave blaga v EU — 46. člen ZDDV-1 — RP-O A3' },
  { value: 'IZD_EU_STORITVE', label: 'Storitve EU (25. člen)', p: 'P10', stopnja: 0, odbitno: false, vasco: 'izdani_eu_storitve', opis: 'Storitve davčnemu zavezancu v EU — kraj obdavčitve pri prejemniku — RP-O A6' },
  { value: 'IZD_TRISTRANSKA', label: 'Tristranska dobava EU', p: 'P11', stopnja: 0, odbitno: false, vasco: 'izdani_tristranska', opis: 'Oproščena tristranska dobava blaga znotraj Unije' },
  { value: 'IZD_PRODAJA_DALJAVA', label: 'Prodaja na daljavo', p: 'P12', stopnja: 0, odbitno: false, vasco: 'izdani_prodaja_daljavo', opis: 'Prodaja blaga na daljavo' },
  { value: 'IZD_EU_MONTAZA', label: 'Dobava z montažo v EU', p: 'P13', stopnja: 0, odbitno: false, vasco: 'izdani_eu_montaza', opis: 'Prodaja blaga z montažo ali napeljavo v EU' },
  { value: 'IZD_IZVOZ', label: 'Izvoz blaga', p: 'P27', stopnja: 0, odbitno: false, vasco: 'izdani_izvoz', opis: 'Izvoz blaga — dobave zunaj SLO s pravico do odbitka' },
  /* [PATCH izdani-ni-predmet-fe v1] promet, ki ne gre v KIR (npr. prevoz potnikov v tujini,
     28. cl. ZDDV-1). Backend: izdani_kontiranje IZD_NI_PREDMET; VOD: Ne_gre_v_knjigo.
     Rocno izbirljiva pri vseh izdanih (odlocitev Janez 07.09.2026). */
  { value: 'IZD_NI_PREDMET', label: 'Ne gre v knjigo', p: '', stopnja: 0, odbitno: false, vasco: 'ne_gre_v_knjigo', opis: 'Ni promet po ZDDV-1 v Sloveniji (npr. prevoz potnikov v tujini, 28. člen) — se ne evidentira v KIR' },
  /* [PATCH izdani-76a-fe v1] 76.a se loci po stopnji -- XSD pozna
     Osnova_splosna_stop_76a_clen (22 %) in Osnova_znizana_stop_76a_clen (9,5 %).
     IZD_76A ostane 22 % -> obstojeci dokumenti so nespremenjeni. */
  { value: 'IZD_76A', label: '76. a. člen (22%)', p: 'P8', stopnja: 0, odbitno: false, vasco: 'izdani_76a', opis: 'Obrnjena davčna obveznost — 76.a člen ZDDV-1, splošna stopnja (izdani)' },
  { value: 'IZD_76A_95', label: '76. a. člen (9,5%)', p: 'P8', stopnja: 0, odbitno: false, vasco: 'izdani_76a', opis: 'Obrnjena davčna obveznost — 76.a člen ZDDV-1, znižana stopnja (izdani)' },
  /* [PATCH oss-temelji v1] OSS (unijska ureditev VEM) — cetrta knjiga DDV.
     Stopnja NI v imenu vrste: je podatek vrstice, ker je po drzavi razlicna
     (AT 20, HR 25, HU 27 ...). p je PRAZEN — OSS ni predmet DDV-O
     (odlocitev Janeza 02.09., NACRT §4.C). stopnja: 0 je le zacetna vrednost;
     ob izbiri drzave se predizpolni s splosno stopnjo te drzave. */
  { value: 'IZD_OSS_BLAGO', label: 'OSS — blago', p: '', stopnja: 0, odbitno: false, vasco: 'izdani_oss_blago', opis: 'OSS unijska ureditev — dobava blaga koncnemu potrosniku v EU (stopnja drzave potrosnje)' },
  { value: 'IZD_OSS_STORITEV', label: 'OSS — storitve', p: '', stopnja: 0, odbitno: false, vasco: 'izdani_oss_storitev', opis: 'OSS unijska ureditev — storitev koncnemu potrosniku v EU (stopnja drzave potrosnje)' },
];

// [PATCH oss-temelji v1] 'oss' je cetrta knjiga poleg domaca/eu/uvoz.
type Knjiga = 'domaca' | 'eu' | 'uvoz' | 'oss';
// [PATCH oss-temelji v1] vrste, ki zahtevajo drzavo potrosnje in vrsto dobave
export const OSS_VRSTE = ['IZD_OSS_BLAGO', 'IZD_OSS_STORITEV'];
export const jeOssVrsta = (vrsta: string): boolean => OSS_VRSTE.includes(String(vrsta || ''));
/* [PATCH oss-temelji v1] B4: vrsta dobave je IZPELJANA iz vrste vrstice, ne
   locen vnos. Za ne-OSS vrste vrne prazen niz (polje se pocisti). */
export const ossDobavaIzVrste = (vrsta: string): '' | 'blago' | 'storitev' =>
  vrsta === 'IZD_OSS_BLAGO' ? 'blago'
  : vrsta === 'IZD_OSS_STORITEV' ? 'storitev'
  : '';

// PATCH_DDV_KNJIGA_IZBIRNIK_V1: zgolj UI filter opcij po Vasco knjigah (1/41/51).
// NE spreminja podatkov ddv_knjige in ne shranjuje nicesar novega.
const KNJIGA_VRSTE: Record<string, Knjiga> = {
  DOM_22: 'domaca', DOM_95: 'domaca', DOM_5: 'domaca',
  NEOBDAVCEN: 'domaca', NI_PREDMET: 'domaca', DOM_NEODB: 'domaca',
  '76A': 'domaca', '76A_KIR': 'domaca', '76A_KPR': 'domaca',
  NEPREMICNINE: 'domaca', OS_DRUGO: 'domaca',
  OPROSCEN: 'domaca', OPROSCEN_NEPREM: 'domaca', OPROSCEN_OS: 'domaca',
  EU_BLAGO: 'eu', EU_STOR: 'eu',
  EU_STOR_KIR: 'eu', EU_STOR_KPR: 'eu', EU_BLAGO_KIR: 'eu', EU_BLAGO_KPR: 'eu',
  UVOZ: 'uvoz',
  IZD_22: 'domaca', IZD_95: 'domaca', IZD_5: 'domaca',
  IZD_OPROSCEN: 'domaca', IZD_EU_OPROSCEN: 'eu', IZD_76A: 'domaca',
  IZD_76A_95: 'domaca',  /* [PATCH izdani-76a-fe v1] brez tega nova vrsta ni vidna v dropdownu */
  /* [PATCH vod-vrste-oproscene v1] brez vpisa tu vrsta izpade iz filtra opcij */
  IZD_EU_STORITVE: 'eu', IZD_TRISTRANSKA: 'eu',
  IZD_PRODAJA_DALJAVA: 'eu', IZD_EU_MONTAZA: 'eu',
  IZD_IZVOZ: 'domaca',  /* KNJIGA_VRSTE pozna le domaca|eu|uvoz; izvoz ni nobeno od njiju */
  IZD_NI_PREDMET: 'domaca',  /* [PATCH izdani-ni-predmet-fe v1] brez vpisa tu vrsta izpade iz filtra opcij */
  /* [PATCH oss-temelji v1] brez vpisa tu vrsta izpade iz filtra opcij */
  IZD_OSS_BLAGO: 'oss', IZD_OSS_STORITEV: 'oss',
};
// PATCH_DDV_KNJIGA_SKRITE_V1: zastarele vrste - dropdown jih ne ponuja vec,
// v podatkih/izvozu ostanejo veljavne (obstojeci dokumenti jih se prikazejo)
const SKRITE_VRSTE = new Set(['NEOBDAVCEN', 'DOM_NEODB', '76A', 'EU_BLAGO', 'EU_STOR']);

// [PATCH ddv-stopnja-vrata v1]
// Stopnja, ki je OCR NI prebral (null / undefined / prazen niz / ne-stevilo).
// POZOR: to NI isto kot legitimna stopnja 0 -- OPROSCEN, NI_PREDMET, IZD_76A
// in IZD_OPROSCEN imajo stopnjo 0 povsem pravilno (84 vrstic na produkciji,
// mereno 29.07.2026) in te MORAJO iti skozi brez ovire.
// Edini vir resnice za to presojo; uvaza ga tudi DokumentiPage.tsx, da UI
// (prazen izbirnik) in vrata ob potrditvi vedno govorita isto.
// [PATCH glava-sync v1] Knjiga vrstice za klicalce IZVEN komponente (DokumentiPage).
// Isto pravilo kot lokalni knjigaVrstice v komponenti: iz VRSTE (vir resnice),
// pri prazni vrstici iz polja "knjiga"; privzeto domaca.
export const knjigaVrsticeDdv = (v: any): string =>
  v?.vrsta ? (KNJIGA_VRSTE[v.vrsta] || 'domaca') : (v?.knjiga || 'domaca');
export const stopnjaNedolocena = (v: any): boolean => {
  const s = v?.stopnja;
  if (s === null || s === undefined || s === '') return true;
  return !Number.isFinite(Number(s));
};
const izpeljiKnjigo = (vrstice: any[]): Knjiga => {
  /* [PATCH oss-temelji v1] oss se preveri prvi: dokument z OSS vrsticami je
     OSS dokument, tudi ce ima poleg njih domaco vrstico. */
  if ((vrstice || []).some((v) => KNJIGA_VRSTE[v?.vrsta] === 'oss')) return 'oss';
  if ((vrstice || []).some((v) => KNJIGA_VRSTE[v?.vrsta] === 'eu')) return 'eu';
  if ((vrstice || []).some((v) => KNJIGA_VRSTE[v?.vrsta] === 'uvoz')) return 'uvoz';
  return 'domaca';
};

interface DdvVrstica {
  vrsta: string;
  stopnja: number;
  osnova: number;
  znesek_ddv: number;
  odbitno: boolean;
  popravek: boolean;
  popravek_obdobje: string;
  vasco: string;
  p_stolpec: string;
  konto_ddv?: string;
  // [PATCH ddv-dodaj-knjigo v1] Pripadnost knjigi SAMO za vrstice BREZ vrste.
  // Prazna vrstica (po preklopu / dodajanju knjige) ne more povedati, kam sodi,
  // ker knjigo sicer izpeljemo iz vrste (KNJIGA_VRSTE). Takoj ko je vrsta
  // izbrana, je VRSTA edini vir resnice in to polje se ne bere vec.
  // Izvozniki (opal.py, vasco.py) ga ne berejo.
  knjiga?: Knjiga;
  /* [PATCH oss-temelji v1] OSS dimenziji. NEOBVEZNI -- obstojeci zapisi brez
     njiju delujejo kot prej; obvezna postaneta sele pri vrsti IZD_OSS_*
     (backend: dokumenti.py _preveri_oss_vrstice). */
  drzava_potrosnje?: string;              // ISO2, npr. 'HR'
  oss_vrsta_dobave?: 'blago' | 'storitev';
  oss_obdobje_popravka?: string;          // 'YYYY-Qn' ali prazno = tekoce
}

export function DdvKnjiga({ kontiranje, selected, onChange, ddvKonti, tabVnos,
                           companyId: companyIdProp }: {
  kontiranje: any;
  selected: any;
  onChange: (k: any) => void;
  ddvKonti?: any;
  tabVnos?: boolean; // [PATCH rocni-vnos-fe v1]
  /* [PATCH oss-temelji v1] C5: OSS sifranti se berejo po podjetju, zato
     komponenta potrebuje company_id. Dokument ga NE nosi (glej porocilo
     1d §1e), zato ga poda stran, ki ga ima v stanju iz selectedCompany. */
  companyId?: string;
}) {
  const zneski = selected?.ocr?.zneski || {};
  // PATCH_DDV_KNJIGA_IZBIRNIK_V1: izbrana knjiga (zgolj prikazni filter)
  // [PATCH ddv-dodaj-knjigo v1] Globalni state "knjiga" odpade: knjiga ni vec
  // lastnost CELE tabele, ampak posamezne SKUPINE vrstic (glej skupine spodaj).
  // izpeljiKnjigo() ostane v datoteki za morebitno prihodnjo rabo.
  // [PATCH ddvknjiga-smer v1] smer dokumenta (isti vir kot filter vrst spodaj)
  const jeIzdaniDok = jeIzdaniTip(selected?.doc_type) || kontiranje?.smer === 'izdani';
  // [PATCH ddv-konto-lib v1] Konto DDV iz profila podjetja prek SKUPNE verige.
  // Prej je bila veriga tu prepisana rocno in je poznala samo kategorijo 'dom';
  // EU / 76.a vrstice so zato dobile DOMACI konto. Zdaj gre vse skozi lib,
  // ki je zrcalo backendove ddv_konto().
  // kontoPoVrsti = pravilna pot (vrsta pove kategorijo IN smer).
  const kontoPoVrsti = (vrsta: string, stopnja: number): string =>
    kontoZaVrsto(ddvKonti, vrsta, stopnja, jeIzdaniDok);
  // kontoZaStopnjo ostane za klicna mesta, ki vrste (se) nimajo — privzeta
  // vrsta dokumenta je domaca, zato je 'dom' tu pravilen.
  const kontoZaStopnjo = (stopnja: number): string =>
    kontoPoVrsti(jeIzdaniDok ? 'IZD_22' : 'DOM_22', stopnja);

  /* ---------------- [PATCH oss-temelji v1] OSS sifranti ------------------ */
  // Drzave EU za izbirnik in stopnje po drzavi na datum DDV dokumenta.
  // Nalozi se SAMO, ce dokument dejansko ima kaksno OSS vrstico -- dokumenti
  // brez OSS ne sprozijo nobene dodatne zahteve.
  const [ossStopnje, setOssStopnje] = useState<Record<string, Array<{ vrsta_stopnje: string; stopnja: number }>>>({});
  const [ossKonti, setOssKonti] = useState<Record<string, any>>({});
  /* [PATCH oss-temelji v1] B2: prazen ossKonti pomeni lahko dvoje --
     "podjetje nima nobene OSS drzave" ali "se ni nalozeno". Brez te
     zastavice opozorilo ni bilo NIKOLI izpisano, ce podjetje ni imelo
     nobene nastavljene drzave. */
  const [ossKontiNalozeni, setOssKontiNalozeni] = useState(false);
  const ossDatum = String(kontiranje?.datumi?.datum_ddv || '').slice(0, 10);
  const imaOss = (kontiranje?.ddv_knjiga || []).some((v: any) => jeOssVrsta(v?.vrsta));
  /* [PATCH oss-temelji v1] C5: prop je PRVI vir. selected/kontiranje sta
     ostala samo kot rezerva -- v odgovoru /dokumenti/{cid} polja
     company_id ni (izmerjeno, glej porocilo 1d §1e). */
  const companyId = companyIdProp || selected?.company_id || kontiranje?.company_id || '';

  /* [PATCH oss-temelji v1] C2: konti OSS podjetja se nalozijo TAKOJ, ko ima
     dokument vsaj eno OSS vrstico -- ne sele po izbiri drzave. Iz njih se
     polni tudi izbirnik drzav (C1), zato /oss/sifrant/drzave ni vec potreben. */
  useEffect(() => {
    if (!imaOss || !companyId || ossKontiNalozeni) return;
    api.get(`/oss/${companyId}/drzave`)
      .then(r => {
        const m: Record<string, any> = {};
        (r.data?.drzave || []).forEach((d: any) => { m[d.drzava] = d; });
        setOssKonti(m);
        setOssKontiNalozeni(true);
      })
      .catch(() => { setOssKonti({}); setOssKontiNalozeni(true); });
  }, [imaOss, companyId, ossKontiNalozeni]);

  /* [PATCH oss-temelji v1] C2: stopnje se nalozijo za VSE nastavljene drzave
     (in povrhu za drzave, ki jih nosijo obstojece vrstice, tudi ce v
     nastavitvah niso), takoj ko so konti znani. Prej so se nalagale sele
     za drzavo, ki je bila ZE zapisana v vrstico -- glej porocilo, vzrok C2. */
  const ossPotrebne = Array.from(new Set<string>([
    ...Object.keys(ossKonti).filter(d => (ossKonti[d] || {}).aktivna !== false),
    ...(kontiranje?.ddv_knjiga || [])
      .filter((v: any) => jeOssVrsta(v?.vrsta) && v?.drzava_potrosnje)
      .map((v: any) => String(v.drzava_potrosnje)),
  ]));
  const ossKljuc = ossPotrebne.slice().sort().join(',') + '|' + ossDatum;
  useEffect(() => {
    if (!imaOss) return;
    const manjkajo = ossPotrebne.filter(d => !ossStopnje[d]);
    if (!manjkajo.length) return;
    Promise.all(manjkajo.map(d =>
      api.get(`/oss/sifrant/stopnje/${d}`, { params: ossDatum ? { na_dan: ossDatum } : {} })
        .then(r => [d, r.data?.stopnje || []] as const)
        .catch(() => [d, []] as const)
    )).then(pari => {
      setOssStopnje(prej => {
        const nov = { ...prej };
        pari.forEach(([d, st]) => { nov[d] = st as any; });
        return nov;
      });
    });
    // odvisnost je namenoma ossKljuc (zgoscen seznam drzav + datum), ne
    // ossPotrebne/ossStopnje: sicer bi se ucinek sprozal ob vsakem izrisu
  }, [imaOss, ossKljuc]);

  // Stopnja vrstice mora biti v sifrantu drzave (toleranca 0,01) -- zrcalo
  // backendove je_veljavna_stopnja(). Dokler stopnje se niso nalozene, ne
  // trdimo, da je napacna (ne rdecimo praznega sifranta).
  const ossStopnjaVeljavna = (v: any): boolean => {
    if (!jeOssVrsta(v?.vrsta)) return true;
    const drz = String(v?.drzava_potrosnje || '');
    if (!drz) return false;
    const st = Number(v?.stopnja);
    if (!Number.isFinite(st)) return false;
    const seznam = ossStopnje[drz];
    if (!seznam) return true;             // se ni nalozeno
    return seznam.some(x => Math.abs(Number(x.stopnja) - st) <= 0.01);
  };

  // Opozorilo, ce konti OSS za to drzavo niso nastavljeni (NACRT §4.B:
  // brez nastavitve polje ostane prazno, brez tihega privzetka).
  /* [PATCH oss-temelji v1] Konto DDV za OSS vrstico pride IZKLJUCNO iz
     nastavitev po drzavi (oss_drzave_konti_ddv), nikoli iz profila podjetja
     -- ddvKonto.ts vrne za kategorijo 'oss' prazen niz. Ce nastavitve za
     drzavo ali stopnjo ni, vrne prazno in vrstica ostane brez konta z
     opozorilom (NACRT §4.B: brez tihega privzetka). */
  const ossKontoZa = (drzava: string, stopnja: any): string => {
    const drz = String(drzava || '');
    const st = Number(stopnja);
    if (!drz || !Number.isFinite(st)) return '';
    const naj = ((ossKonti[drz] || {}).stopnje || [])
      .find((x: any) => Math.abs(Number(x.stopnja) - st) <= 0.01);
    return naj ? String(naj.konto_ddv || '') : '';
  };

  /* [PATCH oss-temelji v1] C4: ob spremembi STOPNJE ali DRZAVE se ohrani
     BRUTO vrstice (odlocitev Janeza 03.09.), ne osnova:
        osnova = round(bruto / (1 + st/100), 2);  DDV = bruto - osnova
     Bruto je osnova + DDV PRED spremembo. Rocna sprememba osnove ostane po
     stari poti (DDV = osnova x stopnja). Zaokrozitev na 2 decimalki je taka,
     da vsota vedno da natanko bruto -- kontrola B3 (+-0,02) to prestane. */
  const ossPreracunBruto = (v: any, novaStopnja: number) => {
    const bruto = Number((Number(v?.osnova || 0) + Number(v?.znesek_ddv || 0)).toFixed(2));
    const st = Number(novaStopnja);
    if (!Number.isFinite(st) || !(bruto > 0)) return {};
    const osnova = Number((bruto / (1 + st / 100)).toFixed(2));
    return { osnova, znesek_ddv: Number((bruto - osnova).toFixed(2)) };
  };

  /* [PATCH oss-temelji v1] C2: ko stopnje in konti prispejo (asinhrono),
     dopolni OSS vrstice, ki jim stopnja ali konto se manjka. Brez tega je
     izracun ob izbiri drzave tekel nad se praznim sifrantom in ga nihce ni
     ponovil. Zapise se SAMO ob dejanski spremembi -- sicer bi se ucinek
     vrtel v krogu. */
  useEffect(() => {
    if (!imaOss) return;
    const vrs = kontiranje?.ddv_knjiga || [];
    let spremenjeno = false;
    const nove = vrs.map((v: any) => {
      if (!jeOssVrsta(v?.vrsta)) return v;
      const drz = String(v?.drzava_potrosnje || '');
      if (!drz) return v;
      const seznam = ossStopnje[drz];
      if (!seznam || !seznam.length) return v;
      let nov = v;
      const st = Number(v?.stopnja);
      const veljavna = Number.isFinite(st)
        && seznam.some(x => Math.abs(Number(x.stopnja) - st) <= 0.01);
      if (!veljavna) {
        const splosna = seznam.find(x => x.vrsta_stopnje === 'splosna') || seznam[0];
        if (splosna) {
          nov = { ...nov, stopnja: splosna.stopnja,
                  ...ossPreracunBruto(nov, splosna.stopnja) };
          spremenjeno = true;
        }
      }
      const zeljeni = ossKontoZa(drz, Number(nov.stopnja));
      if (zeljeni && String(nov.konto_ddv || '') !== zeljeni) {
        nov = { ...nov, konto_ddv: zeljeni };
        spremenjeno = true;
      }
      return nov;
    });
    if (spremenjeno) onChange({ ...kontiranje, ddv_knjiga: nove });
    // sprozi se ob prihodu sifrantov; onChange ni v odvisnostih namenoma
  }, [imaOss, ossStopnje, ossKonti, ossKontiNalozeni]);

  /* [PATCH oss-temelji v1] C1: drzave za izbirnik = nastavljene in aktivne
     drzave podjetja. Drzava, ki jo vrstica ze nosi, a je v nastavitvah ni
     (ali je neaktivna), se doda z oznako "(ni nastavljena)", da se star
     zapis ob odprtju ne pokvari. Naziv in numericna koda prideta iz istega
     odgovora /oss/{cid}/drzave. */
  const ossIzbirneDrzave = (v: any) => {
    const out = Object.keys(ossKonti)
      .filter(d => (ossKonti[d] || {}).aktivna !== false)
      .map(d => ({ iso2: d,
                   naziv_sl: (ossKonti[d] || {}).naziv_sl || d,
                   num: (ossKonti[d] || {}).num || '',
                   nenastavljena: false }))
      .sort((a, b) => a.naziv_sl.localeCompare(b.naziv_sl, 'sl'));
    const drz = String(v?.drzava_potrosnje || '');
    if (drz && !out.some(x => x.iso2 === drz)) {
      const znana = ossKonti[drz] || {};
      out.unshift({ iso2: drz, naziv_sl: znana.naziv_sl || drz,
                    num: znana.num || '', nenastavljena: true });
    }
    return out;
  };

  const ossOpozoriloKonta = (v: any): string => {
    if (!jeOssVrsta(v?.vrsta)) return '';
    const drz = String(v?.drzava_potrosnje || '');
    if (!drz || !ossKontiNalozeni) return '';
    if (!ossKonti[drz]) return `Konti OSS za ${drz} niso nastavljeni.`;
    const st = Number(v?.stopnja);
    const najden = (ossKonti[drz].stopnje || []).find((x: any) => Math.abs(Number(x.stopnja) - st) <= 0.01);
    if (!najden) return `Konto DDV za ${drz} pri ${String(v?.stopnja)} % ni nastavljen.`;
    return '';
  };

  const defaultVrstica: DdvVrstica = jeIzdaniDok ? {
    vrsta: 'IZD_22',
    stopnja: 22,
    osnova: Number(zneski.skupaj_brez_ddv || 0),
    znesek_ddv: Number(zneski.znesek_ddv || 0),
    odbitno: true,
    popravek: false,
    popravek_obdobje: '',
    vasco: 'izdani_visja',
    p_stolpec: 'P7',  /* [PATCH vod-vrste-oproscene v1] KIR stolpec */
    konto_ddv: kontoZaStopnjo(22),
  } : {
    vrsta: 'DOM_22',
    stopnja: 22,
    osnova: Number(zneski.skupaj_brez_ddv || 0),
    znesek_ddv: Number(zneski.znesek_ddv || 0),
    odbitno: true,
    popravek: false,
    popravek_obdobje: '',
    vasco: 'ddv_visja_vstopni',
    p_stolpec: 'P8',
    konto_ddv: kontoZaStopnjo(22),
  };

  const vrstice: DdvVrstica[] = kontiranje?.ddv_knjiga?.length
    ? kontiranje.ddv_knjiga
    : [defaultVrstica];

  // [PATCH ddv-knjiga-preklop v1] PRAZNA vrstica DDV evidence.
  // stopnja = null (NE 0!) -> stopnjaNedolocena() vrne true -> izbirnik Vrsta
  // je prazen z rdecim robom in preveriDdvKnjigo() blokira potrditev, dokler
  // uporabnik ne izbere vrste. Stopnja 0 je LEGITIMNA (OPROSCEN, NI_PREDMET,
  // 76.a) in bi jo sistem imel za pravilno vrstico.
  const praznaVrstica = (kn: Knjiga = 'domaca'): DdvVrstica => ({
    vrsta: '', stopnja: null as any, osnova: 0, znesek_ddv: 0,
    odbitno: true, popravek: false, popravek_obdobje: '',
    vasco: '', p_stolpec: '', konto_ddv: '',
    knjiga: kn, /* [PATCH ddv-dodaj-knjigo v1] pripadnost, dokler ni vrste */
  });

  // [PATCH ddv-dodaj-knjigo v1] Knjiga vrstice: iz VRSTE (vir resnice), pri
  // prazni vrstici iz polja "knjiga".
  const knjigaVrstice = (v: any): Knjiga =>
    v?.vrsta ? ((KNJIGA_VRSTE[v.vrsta] || 'domaca') as any)
             : ((v?.knjiga || 'domaca') as any);
  const VSE_KNJIGE: Array<Knjiga> = ['domaca', 'eu', 'uvoz', 'oss'];  /* [PATCH oss-temelji v1] */
  const OZNAKA_KNJIGE: Record<string, string> = { domaca: 'doma\u010da', eu: 'EU', uvoz: 'uvoz', oss: 'OSS' };

  /* [PATCH oss-temelji v1] 2e: konto PRIHODKOV iz nastavitev OSS (odlocitev
     Janeza 04.09.: "ce so v nastavitvah konti nastavljeni, vedno jemlje
     tiste"). Prazen niz pomeni "za to drzavo/dobavo ni nastavljen" -- takrat
     ostane konto, ki je ze v knjizbi (rezerva, brez tihega privzetka). */
  const ossKontoPrihodkovZa = (drzava: string, dobava: string): string => {
    const n = ossKonti[String(drzava || '')] || null;
    if (!n) return '';
    return String((dobava === 'storitev' ? n.konto_prihodki_storitve
                                         : n.konto_prihodki_blago) || '');
  };

  /* Knjizba prihodkov: naziv je vir resnice, ne stevilka konta -- po zamenjavi
     iz nastavitev konto ni nujno vec 76xxx (nastavitev sme kazati kamorkoli). */
  const jePrihodkovna = (kb: any) =>
    String(kb?.naziv || '').startsWith('Prihodki') || String(kb?.konto || '').startsWith('76');

  /* Knjizb prihodkov je vec (ali nobene) -> uparjanje z OSS vrstico ni
     enolicno; konta ne zamenjamo, uporabnika samo opozorimo (§2.3). */
  const ossPrihodkiDvoumni = (): string => {
    const v: any = (vrstice || []).find((x: any) => jeOssVrsta(x?.vrsta) && x?.drzava_potrosnje);
    if (!v) return '';
    const konto = ossKontoPrihodkovZa(String(v.drzava_potrosnje || ''),
                                      String(v.oss_vrsta_dobave || 'blago'));
    if (!konto) return '';
    const n = ((kontiranje as any)?.knjizbe || []).filter(jePrihodkovna).length;
    return n === 1 ? '' : `${v.drzava_potrosnje}/${v.oss_vrsta_dobave || 'blago'}: ${konto}`;
  };

  const updateVrstica = (i: number, changes: Partial<DdvVrstica>,
                         osveziPrihodke = false) => {
    const k = { ...kontiranje };
    const nove = [...vrstice];
    nove[i] = { ...nove[i], ...changes };
    /* [PATCH oss-temelji v1] B4: vrsta dobave se USKLADI z vrsto na vsaki
       spremembi -- tudi pri starih zapisih, ki polja se nimajo, in pri
       vrsticah, ki so vrsto zamenjale iz OSS v kaj drugega. To je edini
       lijak za spremembe vrstic, zato tu zadostuje. */
    const uskladjene = nove.map((v: any) => {
      const dobava = ossDobavaIzVrste(v?.vrsta);
      if (dobava && v?.oss_vrsta_dobave !== dobava) return { ...v, oss_vrsta_dobave: dobava };
      if (!dobava && v?.oss_vrsta_dobave) {
        const { oss_vrsta_dobave, ...brez } = v;
        return brez;
      }
      return v;
    });
    k.ddv_knjiga = uskladjene;
    /* [PATCH oss-temelji v1] 2e: ob spremembi DRZAVE ali DOBAVE (torej ob
       dogodku, ne v izracunih in ne ob vsakem izrisu) konto knjizbe prihodkov
       sledi nastavitvam OSS. Zamenja se SAMO, kadar je knjizba prihodkov ENA;
       sicer uparjanje ni enolicno in ostane na uporabniku (opozorilo v maski).
       Rocni popravek konta po tem obstane: DokumentiPage pri OSS bere konto iz
       obstojece knjizbe in ne iz konto_stroska. */
    if (osveziPrihodke) {
      const vv: any = uskladjene[i] || {};
      const konto = ossKontoPrihodkovZa(String(vv.drzava_potrosnje || ''),
                                        String(vv.oss_vrsta_dobave || 'blago'));
      if (konto) {
        const knj = [...((k as any).knjizbe || [])];
        const idx = knj.map((kb: any, j: number) => (jePrihodkovna(kb) ? j : -1))
                       .filter((j: number) => j >= 0);
        if (idx.length === 1) {
          knj[idx[0]] = { ...knj[idx[0]], konto };
          (k as any).knjizbe = knj;
        }
        /* rezerva, kadar knjizb se ni (prva vrstica na novem dokumentu) */
        (k as any).konto_stroska = konto;
      }
    }
    onChange(k);
  };

  // [PATCH ddv-autofill v1] samodejno razbitje preostanka racuna na osnovo in DDV
  const KIR_AVTO = ['76A_KIR', 'EU_STOR_KIR', 'EU_BLAGO_KIR'];
  const KPR_AVTO = ['76A_KPR', 'EU_STOR_KPR', 'EU_BLAGO_KPR'];
  const SOLO_SAMOOBD = ['76A', 'EU_BLAGO', 'EU_STOR'];
  const jeSamoobdVrsta = (vrsta: string) => KIR_AVTO.includes(vrsta) || KPR_AVTO.includes(vrsta) || SOLO_SAMOOBD.includes(vrsta);
  // prispevek vrstice do bruta: samoobdavcitveni par steje osnovo enkrat (KIR),
  // KPR nic -- DDV pri samoobdavcitvi ni del zneska racuna
  const prispevekDoBruta = (v: DdvVrstica): number => {
    if (KPR_AVTO.includes(v.vrsta)) return 0;
    if (KIR_AVTO.includes(v.vrsta) || SOLO_SAMOOBD.includes(v.vrsta)) return Number(v.osnova || 0);
    return Number(v.osnova || 0) + Number(v.znesek_ddv || 0);
  };
  // preostanek = bruto (Skupaj z DDV, isti vir kot glava maske) - vsota prispevkov
  // vseh vrstic razen izpuscene (izpusti = -1 -> vse vrstice)
  const preostanekBrez = (izpusti: number): number => {
    const bruto = Number(kontiranje?.ocr_zneski?.skupaj_z_ddv ?? selected?.ocr?.zneski?.skupaj_z_ddv ?? 0);
    const vsota = vrstice.reduce((s, v, idx) => (idx === izpusti ? s : s + prispevekDoBruta(v)), 0);
    return Number((bruto - vsota).toFixed(2));
  };
  // razbij znesek po vrsti: stopnja s>0 -> osnova = znesek/(1+s), ddv = razlika
  // (vsota se izide na cent); 0% -> vse v osnovo; samoobdavcitev -> osnova =
  // znesek, ddv = osnova*s
  const razbijZnesek = (znesek: number, info: { value: string; stopnja: number }): { osnova: number; znesek_ddv: number } => {
    if (!(znesek > 0)) return { osnova: 0, znesek_ddv: 0 };
    const s = Number(info.stopnja || 0);
    if (!(s > 0)) return { osnova: znesek, znesek_ddv: 0 };
    if (jeSamoobdVrsta(info.value)) return { osnova: znesek, znesek_ddv: Number((znesek * s / 100).toFixed(2)) };
    const osnova = Number((znesek / (1 + s / 100)).toFixed(2));
    return { osnova, znesek_ddv: Number((znesek - osnova).toFixed(2)) };
  };
  // [PATCH ddv-dodaj-knjigo v1] nova vrstica se doda V SVOJO skupino.
  // Za privzeto knjigo dokumenta ostane staro vedenje (privzeta vrsta +
  // razbit preostanek, [PATCH ddv-autofill v1]); druge knjige dobijo PRAZNO
  // vrstico, ker privzete vrste zanje ni.
  const privzetaKnjiga: Knjiga =
    (KNJIGA_VRSTE[defaultVrstica.vrsta] || 'domaca') as any;
  const dodajVrstico = (kn: Knjiga = privzetaKnjiga) => {
    const k = { ...kontiranje };
    if (kn === privzetaKnjiga) {
      const defInfo = VRSTE_DDV.find(x => x.value === defaultVrstica.vrsta) || VRSTE_DDV[0];
      const avto = razbijZnesek(preostanekBrez(-1), defInfo);
      k.ddv_knjiga = [...vrstice, { ...defaultVrstica, ...avto }];
    } else {
      k.ddv_knjiga = [...vrstice, praznaVrstica(kn)];
    }
    onChange(k);
  };

  // [PATCH ddv-dodaj-knjigo v1] Nova KNJIGA: prva se neuporabljena.
  // EU dobi PAR (KIR + KPR), ker EU brez para ni veljaven.
  const dodajKnjigo = () => {
    const zasedene = vrstice.map(knjigaVrstice);
    const prosta = VSE_KNJIGE.find(kn => !zasedene.includes(kn));
    if (!prosta) return;
    const nove = prosta === 'eu' ? [praznaVrstica('eu'), praznaVrstica('eu')] : [praznaVrstica(prosta)];
    onChange({ ...kontiranje, ddv_knjiga: [...vrstice, ...nove] });
  };

  // Preklop knjige ZNOTRAJ skupine: zamenja SAMO vrstice te skupine
  // (pred tem patchem je preklop pobrisal VSE vrstice dokumenta).
  // Opomba: nove vrstice se pripnejo na konec, zato se vrstni red skupin
  // lahko spremeni -- vsebinsko je nepomembno, izvoz vrstnega reda ne bere.
  // [PATCH eu-izbira v1] Storitev/Blago za EU skupino: obe vrstici (KIR + KPR) dobita vrsto,
  // stopnjo, odbitno, vasco, p_stolpec, konto DDV (kontoPoVrsti) -- ista polja kot rocna izbira
  // vrste v izbirniku, v ENEM klicu onChange.
  // [PATCH eu-izbira v2] gumba sta stalno vidna; klik na drugega ZAMENJA vrsti obeh vrstic.
  // Prazna vrstica dobi osnovo iz GLAVE, ze izpolnjena obdrzi svojo; DDV = osnova x stopnja.
  // KIR/KPR vloga vrstice se ohrani (po KIR_AVTO/KPR_AVTO), pri praznih: prva KIR, druga KPR.
  const izberiEuPar = (kirVrsta: string, kprVrsta: string) => {
    const osnGlava = Number(kontiranje?.ocr_zneski?.skupaj_brez_ddv ?? selected?.ocr?.zneski?.skupaj_brez_ddv ?? 0);
    const napolni = (v: any, vrsta: string) => {
      const info = VRSTE_DDV.find(x => x.value === vrsta);
      if (!info) return v;
      const st = Number(info.stopnja);
      const osn = stopnjaNedolocena(v) ? osnGlava : Number(v?.osnova || 0);
      return { ...v, vrsta, stopnja: st, odbitno: info.odbitno, vasco: info.vasco, p_stolpec: info.p,
        konto_ddv: kontoPoVrsti(vrsta, st), osnova: osn, znesek_ddv: Number((osn * st / 100).toFixed(2)) };
    };
    const euIdx = vrstice.map((v, i) => ({ v, i })).filter(x => knjigaVrstice(x.v) === 'eu').map(x => x.i);
    if (euIdx.length !== 2) return;
    const [a, b] = euIdx;
    const aJeKpr = KPR_AVTO.includes(String(vrstice[a]?.vrsta || '')) && !KPR_AVTO.includes(String(vrstice[b]?.vrsta || ''));
    const iKir = aJeKpr ? b : a, iKpr = aJeKpr ? a : b;
    const nove = [...vrstice];
    nove[iKir] = napolni(nove[iKir], kirVrsta);
    nove[iKpr] = napolni(nove[iKpr], kprVrsta);
    onChange({ ...kontiranje, ddv_knjiga: nove });
  };
  // [PATCH eu-izbira v2] aktivna izbira EU skupine za obarvanje gumbov
  const euIzbrano = (idx: number[]): '' | 'stor' | 'blago' => {
    const vr = idx.map(i => String(vrstice[i]?.vrsta || ''));
    if (vr.some(x => x.startsWith('EU_STOR'))) return 'stor';
    if (vr.some(x => x.startsWith('EU_BLAGO'))) return 'blago';
    return '';
  };
  const euGumb = (aktiven: boolean) => 'text-[10px] px-2 py-0.5 rounded border border-blue-500 '
    + (aktiven ? 'bg-blue-600 text-white' : 'text-blue-500 hover:bg-blue-500 hover:text-white');

  const zamenjajKnjigo = (stara: Knjiga, nova: Knjiga) => {
    if (stara === nova) return;
    if (vrstice.some(v => knjigaVrstice(v) === nova)) return; // knjiga ze obstaja
    const ostale = vrstice.filter(v => knjigaVrstice(v) !== stara);
    const nove = nova === 'eu' ? [praznaVrstica('eu'), praznaVrstica('eu')] : [praznaVrstica(nova)];
    onChange({ ...kontiranje, ddv_knjiga: [...ostale, ...nove] });
  };

  const odstraniKnjigo = (kn: Knjiga) => {
    const preostale = vrstice.filter(v => knjigaVrstice(v) !== kn);
    if (!preostale.length) return; // zadnja skupina se ne odstrani
    onChange({ ...kontiranje, ddv_knjiga: preostale });
  };

  const odstraniVrstico = (i: number) => {
    if (vrstice.length <= 1) return;
    const k = { ...kontiranje };
    k.ddv_knjiga = vrstice.filter((_, idx) => idx !== i);
    onChange(k);
  };

  const EU_KIR_VRSTE = ['EU_STOR_KIR','EU_BLAGO_KIR'];
  const EU_KPR_VRSTE = ['EU_STOR_KPR','EU_BLAGO_KPR'];
  // Pri samoobdavčitvi (KIR+KPR par) osnova se ne sešteva - prikazana je samo enkrat
  const skupajOsnova = useMemo(() => {
    const kirVrstice = vrstice.filter(v => EU_KIR_VRSTE.includes(v.vrsta));
    const kprVrstice = vrstice.filter(v => EU_KPR_VRSTE.includes(v.vrsta));
    const ostale = vrstice.filter(v => !EU_KIR_VRSTE.includes(v.vrsta) && !EU_KPR_VRSTE.includes(v.vrsta));
    // KIR in KPR imata isto osnovo - štej samo enkrat (KIR)
    const euOsnova = kirVrstice.reduce((s, v) => s + Number(v.osnova), 0);
    const ostalaOsnova = ostale.reduce((s, v) => s + Number(v.osnova), 0);
    return euOsnova + ostalaOsnova;
  }, [vrstice]);
  const skupajDdv = useMemo(() => {
    // DDV prav tako štej samo enkrat (KPR = vstopni odbiten)
    const kprVrstice = vrstice.filter(v => EU_KPR_VRSTE.includes(v.vrsta));
    const ostale = vrstice.filter(v => !EU_KIR_VRSTE.includes(v.vrsta) && !EU_KPR_VRSTE.includes(v.vrsta));
    return kprVrstice.reduce((s, v) => s + Number(v.znesek_ddv), 0) + ostale.reduce((s, v) => s + Number(v.znesek_ddv), 0);
  }, [vrstice]);

  // [PATCH ddv-vsota-kontrola v1] NETO DDV evidence proti DDV v glavi racuna.
  // Pravilo (Janez, 24.08.2026): vstopni in obracunani DDV se ODSTEJETA.
  //   neto = SUM(DDV vrstic, ki NISO KIR) - SUM(DDV vrstic KIR)
  // Samoobdavcitveni par (KIR 431,39 + KPR 431,39) da neto 0 in se ujema z
  // glavo 0,00 -> brez opozorila. Domaca vrstica 87,05 proti glavi 0,00 -> rdece.
  // Stare ENOJNE samoobdavcitvene vrste (76A, EU_BLAGO, EU_STOR; SKRITE_VRSTE)
  // se IZPUSTIJO -- ena taka vrstica pomeni KIR in KPR hkrati, enako jih ze
  // izpusca prispevekDoBruta(). Neodbitni DDV steje normalno: na racunu je,
  // samo odbiti se ne sme.
  const ddvGlava = Number(kontiranje?.ocr_zneski?.znesek_ddv ?? selected?.ocr?.zneski?.znesek_ddv ?? 0);
  const netoDdv = useMemo(() => Number(vrstice.reduce((s, v) => {
    if (SOLO_SAMOOBD.includes(v.vrsta)) return s;
    const z = Number(v.znesek_ddv || 0);
    return s + (KIR_AVTO.includes(v.vrsta) ? -z : z);
  }, 0).toFixed(2)), [vrstice]);
  // toleranca 0,02 = isti cent kot razrez in VOD parjenje (DDV_KONTROLA_TOL v
  // DokumentiPage je 0,05 in velja za DRUGO kontrolo -- osnova x stopnja po
  // vrstici, kjer se sestevajo zaokrozitve po postavkah dobavitelja).
  const ddvAvansIzvzem = vrstice.reduce((s: number, v: any) => s + (v && v._avans_link ? (Number(v.znesek_ddv) || 0) : 0), 0); // [PATCH glava-avans-izvzem-fe v1] storno DDV avansa ni del DDV na racunu
  const ddvNeujemanje = Math.abs(netoDdv - ddvAvansIzvzem - ddvGlava) > 0.02; // [PATCH glava-avans-izvzem-fe v1]
  const ddvNaslov = ddvNeujemanje
    ? 'Vsota DDV v evidenci (neto ' + fmt(netoDdv) + ') se ne ujema z DDV na racunu (' + fmt(ddvGlava) + '). Vstopni in obracunani DDV se odstejeta.'
    : 'Neto DDV evidence se ujema z DDV na racunu.';

  // [PATCH ddv-dodaj-knjigo v1] Skupine vrstic po knjigi, v vrstnem redu
  // prve pojavitve. Prazna tabela -> ena skupina s privzeto knjigo dokumenta.
  const skupine = useMemo(() => {
    const red: Array<Knjiga> = [];
    vrstice.forEach(v => { const kn = knjigaVrstice(v); if (!red.includes(kn)) red.push(kn); });
    if (!red.length) red.push(privzetaKnjiga);
    return red.map(kn => ({
      knjiga: kn,
      idx: vrstice.map((v, i) => ({ v, i })).filter(x => knjigaVrstice(x.v) === kn).map(x => x.i),
    }));
    // eslint-disable-next-line
  }, [vrstice]);
  const vecSkupin = skupine.length > 1;
  const vseKnjigeZasedene = skupine.length >= VSE_KNJIGE.length;

  // [PATCH nezavezanec-prejeti-fe v1] Nezavezanec za DDV: backend zapise kontiranje.nezavezanec_ddv=true
  // in eno vrstico NI_PREDMET (osnova = bruto). Evidenca je BRALNA: brez izbirnikov, brez + Dodaj.
  // Dokumenti brez kljuca (stari, zavezanci) gredo po stari poti nespremenjeno.
  if ((kontiranje as any)?.nezavezanec_ddv === true) {
    const nzV = (((kontiranje as any)?.ddv_knjiga || [])[0]) || {};
    const nzF = (x: any) => Number(x || 0).toLocaleString('sl-SI', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (
      <div className="rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-sm">
        <div className="font-medium">Nezavezanec za DDV — ne gre v knjigo</div>
        <div className="text-xs opacity-80">
          Vrsta: Ni predmet DDV (ne gre v knjigo) · Osnova (bruto): {nzF(nzV.osnova)} EUR · DDV: {nzF(nzV.znesek_ddv)} EUR
        </div>
      </div>
    );
  }
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
      <table className="w-full text-xs">
        <thead className="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th className="px-2 py-2 text-left text-gray-500">FURS</th>{/* [PATCH furs-naslov v1] prej: Vrsta (FURS stolpec) */}
            <th className="px-2 py-2 text-right text-gray-500">Osnova</th>
            <th className="px-2 py-2 text-right text-gray-500">DDV</th>
            <th className="px-2 py-2 text-center text-gray-500" title="Odbitni DDV">Odb.</th>
            <th className="px-2 py-2 text-center text-gray-500" title="Popravek DDV za pretekla obdobja">Pop.</th>
            <th className="px-2 py-2 text-left text-gray-500">Obdobje</th>
            <th className="px-1 py-2"></th>
          </tr>
        </thead>
        {skupine.map(sk => (
          <tbody key={sk.knjiga} className="divide-y divide-gray-100 dark:divide-gray-800 border-t border-gray-200 dark:border-gray-700">
            {/* glava skupine: izbirnik knjige + odstranitev skupine */}
            <tr className="bg-gray-50/60 dark:bg-gray-800/40">
              <td colSpan={7} className="px-2 py-1">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] uppercase tracking-wide text-gray-400">Knjiga</span>
                  <select
                    tabIndex={tabVnos ? -1 : undefined}
                    value={sk.knjiga}
                    onChange={e => zamenjajKnjigo(sk.knjiga, e.target.value as Knjiga)}
                    title="Preklop knjige zamenja vrstice TE skupine z novimi, praznimi."
                    className="bg-gray-800 text-white text-[10px] rounded px-1 py-0.5 outline-none border border-gray-600">
                    {VSE_KNJIGE.map(kn => (
                      <option key={kn} value={kn} disabled={kn !== sk.knjiga && skupine.some(s => s.knjiga === kn)}>
                        {OZNAKA_KNJIGE[kn]}
                      </option>
                    ))}
                  </select>
                  {/* [PATCH eu-izbira v1] gumba Storitev / Blago; [PATCH eu-izbira v2] stalno vidna, aktivni obarvan */}
                  {sk.knjiga === 'eu' && sk.idx.length === 2 && (
                    <span className="flex items-center gap-1">
                      <button type="button" tabIndex={tabVnos ? -1 : undefined} onClick={() => izberiEuPar('EU_STOR_KIR', 'EU_STOR_KPR')}
                        title="Storitve EU: obracunani KIR (P18) + vstopni KPR (P11/P18)"
                        className={euGumb(euIzbrano(sk.idx) === 'stor')}>Storitev</button>
                      <button type="button" tabIndex={tabVnos ? -1 : undefined} onClick={() => izberiEuPar('EU_BLAGO_KIR', 'EU_BLAGO_KPR')}
                        title="Blago EU: obracunani KIR (P18) + vstopni KPR (P10/P18)"
                        className={euGumb(euIzbrano(sk.idx) === 'blago')}>Blago</button>
                    </span>
                  )}
                  {vecSkupin && (
                    <button tabIndex={tabVnos ? -1 : undefined} onClick={() => odstraniKnjigo(sk.knjiga)}
                      title="Odstrani to knjigo z vsemi njenimi vrsticami"
                      className="text-red-400 hover:text-red-300 text-[10px]">odstrani knjigo</button>
                  )}
                </div>
              </td>
            </tr>
            {sk.idx.map(i => {
              const v = vrstice[i];
              const vrstaInfo = VRSTE_DDV.find(x => x.value === v.vrsta) || VRSTE_DDV[0];
              return (
                <tr key={i} className="bg-white dark:bg-gray-900">
                  <td className="px-2 py-1.5">
                    <select
                      tabIndex={tabVnos ? (i === 0 ? 12 : 0) : undefined}
                      onBlur={() => { if (tabVnos) updateVrstica(i, {}); }}
                      value={stopnjaNedolocena(v) ? '' : v.vrsta}
                      onChange={e => {
                        const info = VRSTE_DDV.find(x => x.value === e.target.value) || VRSTE_DDV[0];
                        // [PATCH ddv-autofill v1] + [PATCH ddv-knjiga-preklop v1]
                        const preost = preostanekBrez(i);
                        const bilaPrazna = stopnjaNedolocena(v);
                        const _iPar = KIR_AVTO.indexOf(e.target.value);
                        const _iParK = KPR_AVTO.indexOf(e.target.value);
                        const parVrsta = _iPar >= 0 ? KPR_AVTO[_iPar] : (_iParK >= 0 ? KIR_AVTO[_iParK] : '');
                        const partner = parVrsta ? vrstice.find((x, xi) => xi !== i && x.vrsta === parVrsta && Number(x.osnova || 0) > 0) : undefined;
                        const pokriva = bilaPrazna || (vrstice.length > 1 && preost > 0 && Math.abs((Number(v.osnova || 0) + Number(v.znesek_ddv || 0)) - preost) < 0.011);
                        const novaVrsta = e.target.value;
                        /* [PATCH oss-uvoz v1] D1: pri prehodu v OSS vrsto
                           stopnja NE sme priti iz VRSTE_DDV (tam je 0) --
                           OSS stopnjo doloca drzava potrosnje. Ce jo
                           vrstica ze ima, jo obdrzimo (bruto ostane
                           nedotaknjen); sicer jo dopolni ucinek C2, ko
                           je izbrana drzava. Za ne-OSS vrste je vedenje
                           nespremenjeno. */
                        const stopnjaNova = jeOssVrsta(novaVrsta)
                          ? (Number.isFinite(Number(v.stopnja)) ? Number(v.stopnja) : 0)
                          : info.stopnja;
                        const infoZn = { value: novaVrsta, stopnja: stopnjaNova };
                        const zneska = partner
                          ? { osnova: Number(partner.osnova || 0), znesek_ddv: Number(partner.znesek_ddv || 0) }
                          : (pokriva ? razbijZnesek(preost, infoZn) : { osnova: Number(v.osnova || 0), znesek_ddv: Number((Number(v.osnova || 0) * stopnjaNova / 100).toFixed(2)) });
                        /* [PATCH oss-temelji v1] C3: preklop med OSS vrstama
                           (blago <-> storitve) je SAMO sprememba vrste in
                           izpeljane dobave. Drzava, stopnja, zneska in konto
                           DDV ostanejo -- to niso lastnosti vrste, ampak
                           drzave potrosnje. Prehod OSS <-> ne-OSS gre po
                           obstojeci poti spodaj. */
                        if (jeOssVrsta(v.vrsta) && jeOssVrsta(novaVrsta)) {
                          updateVrstica(i, {
                            vrsta: novaVrsta,
                            vasco: info.vasco,
                            p_stolpec: info.p,
                            odbitno: info.odbitno,
                            oss_vrsta_dobave: ossDobavaIzVrste(novaVrsta) || undefined,
                            /* [PATCH oss-temelji v1] 2e: preklop blago <->
                               storitve zamenja tudi konto prihodkov (navodila
                               §2.2) -- nastavitev ima locen konto za vsako
                               dobavo, zato mora slediti tudi vrsti, ne le
                               drzavi */
                          } as any, true);
                          return;
                        }
                        updateVrstica(i, {
                          vrsta: novaVrsta,
                          stopnja: stopnjaNova,   /* [PATCH oss-uvoz v1] D1 */
                          odbitno: info.odbitno,
                          vasco: info.vasco,
                          p_stolpec: info.p,
                          konto_ddv: kontoPoVrsti(novaVrsta, stopnjaNova),
                          /* [PATCH oss-temelji v1] B4: dobava sledi vrsti;
                             pri ne-OSS vrsti se polje pocisti, da za njimi
                             ne ostane star zapis */
                          oss_vrsta_dobave: ossDobavaIzVrste(novaVrsta) || undefined,
                          ...zneska,
                          /* [PATCH oss-temelji v1] 2e: prehod ne-OSS -> OSS
                             prav tako dobi konto prihodkov iz nastavitev */
                        } as any, jeOssVrsta(novaVrsta));
                      }}
                      className={`bg-gray-800 text-white text-xs rounded px-1 py-0.5 outline-none w-full max-w-[220px] border ${stopnjaNedolocena(v) ? 'border-red-500' : 'border-gray-600'}`}
                      title={vrstaInfo.opis}
                    >
                      {stopnjaNedolocena(v) && <option value="" disabled>{'\u2014 izberi vrsto \u2014'}</option>}
                      {(() => {
                        /* [PATCH ddv-dodaj-knjigo v1] filter po knjigi TE SKUPINE, ne globalni */
                        const opcije: any[] = VRSTE_DDV.filter(vr => vr.value === v.vrsta || (!SKRITE_VRSTE.has(vr.value) && (KNJIGA_VRSTE[vr.value] || 'domaca') === sk.knjiga && (vr.value.startsWith('IZD_') === (jeIzdaniTip(selected?.doc_type)))));
                        const stKrat: Record<string, number> = {};
                        opcije.forEach(o => { stKrat[o.label] = (stKrat[o.label] || 0) + 1; });
                        return opcije.map(vr => (
                          <option key={vr.value} value={vr.value} title={vr.opis}>{stKrat[vr.label] > 1 ? vr.label + (vr.value.startsWith('IZD_') ? ' (izdani)' : ' (prejeti)') : vr.label}</option>
                        ));
                      })()}
                    </select>
                    {/* [PATCH oss-temelji v1] OSS dimenziji: drzava potrosnje in
                        vrsta dobave. Prikazeta se SAMO pri vrsti IZD_OSS_*, zato
                        se za vse ostale vrste ne spremeni nic. Stolpcev tabele
                        namenoma ne dodajamo -- kontrolniki so v celici Vrsta. */}
                    {jeOssVrsta(v.vrsta) && (
                      <div className="mt-1 space-y-1">
                        <div className="flex gap-1">
                          <select
                            tabIndex={tabVnos ? -1 : undefined}
                            value={v.drzava_potrosnje || ''}
                            onChange={e => {
                              const drz = e.target.value;
                              /* stopnja se predizpolni s SPLOSNO stopnjo drzave;
                                 uporabnik jo lahko zamenja z drugo veljavno */
                              const st = (ossStopnje[drz] || []).find(x => x.vrsta_stopnje === 'splosna');
                              const nStopnja = st ? st.stopnja : Number(v.stopnja);
                              updateVrstica(i, {
                                drzava_potrosnje: drz,
                                /* [PATCH oss-temelji v1] C4: ohrani BRUTO, ne osnove */
                                ...(st ? { stopnja: st.stopnja, ...ossPreracunBruto(v, st.stopnja) } : {}),
                                /* [PATCH oss-temelji v1] konto DDV iz OSS nastavitev */
                                konto_ddv: ossKontoZa(drz, nStopnja),
                                /* [PATCH oss-temelji v1] 2e: konto prihodkov
                                   sledi drzavi (tretji argument = osvezi) */
                              } as any, true);
                            }}
                            className={`bg-gray-800 text-white text-xs rounded px-1 py-0.5 outline-none border ${v.drzava_potrosnje ? 'border-gray-600' : 'border-red-500'}`}
                            title="Drzava potrosnje (OSS)"
                          >
                            <option value="">{'\u2014 dr\u017eava \u2014'}</option>
                            {/* [PATCH oss-temelji v1] C1: izbirnik ponuja SAMO
                                drzave, ki jih ima podjetje nastavljene in so
                                aktivne (GET /oss/{cid}/drzave). Drzavo, ki jo
                                vrstica ze nosi, a v nastavitvah (vec) ni,
                                vseeno prikazemo -- da se star zapis ne pokvari. */}
                            {ossIzbirneDrzave(v).map(d => (
                              <option key={d.iso2} value={d.iso2}>
                                {d.naziv_sl} {d.iso2} {d.num}{d.nenastavljena ? ' (ni nastavljena)' : ''}
                              </option>
                            ))}
                          </select>
                          {/* [PATCH oss-temelji v1] B4: vrsta dobave NI vec
                              izbirnik -- izpelje se iz vrste vrstice
                              (IZD_OSS_BLAGO -> blago, IZD_OSS_STORITEV ->
                              storitev). Dvojni vnos iste informacije je bil
                              vir neskladja. Prikaz je samo informativen. */}
                          <span className="text-xs text-gray-400 px-1 py-0.5 self-center">
                            {ossDobavaIzVrste(v.vrsta)}
                          </span>
                        </div>
                        <div className="flex gap-1 items-center">
                          <select
                            tabIndex={tabVnos ? -1 : undefined}
                            value={String(v.stopnja ?? '')}
                            onChange={e => {
                              const st = Number(e.target.value);
                              updateVrstica(i, {
                                stopnja: st,
                                /* [PATCH oss-temelji v1] C4: ohrani BRUTO vrstice */
                                ...ossPreracunBruto(v, st),
                                /* [PATCH oss-temelji v1] konto DDV sledi stopnji */
                                konto_ddv: ossKontoZa(String(v.drzava_potrosnje || ''), st),
                              } as any);
                            }}
                            className={`bg-gray-800 text-white text-xs rounded px-1 py-0.5 outline-none border ${ossStopnjaVeljavna(v) ? 'border-gray-600' : 'border-red-500'}`}
                            title="Stopnja DDV drzave potrosnje"
                          >
                            <option value="">{'\u2014 stopnja \u2014'}</option>
                            {(ossStopnje[v.drzava_potrosnje || ''] || []).map(s => (
                              /* [PATCH oss-temelji v1] kljuc je STOPNJA, ne reza:
                                 nov unikat (drzava, stopnja, velja_od) dopusca
                                 vec nizjih stopenj z isto rezo */
                              <option key={String(s.stopnja)} value={String(s.stopnja)}>
                                {String(s.stopnja).replace('.', ',')} %
                              </option>
                            ))}
                          </select>
                          {/* [PATCH oss-popravek-prikaz v1] polje SAMO pri popravku
                              (kljukica Pop. ali ze vpisano obdobje); sicer ga ni */}
                          {(v.popravek || v.oss_obdobje_popravka) && (
                            <input
                              tabIndex={tabVnos ? -1 : undefined}
                              value={v.oss_obdobje_popravka || ''}
                              onChange={e => updateVrstica(i, { oss_obdobje_popravka: e.target.value } as any)}
                              placeholder="npr. 2026-Q2"
                              className="w-28 bg-gray-800 text-white text-xs rounded px-1 py-0.5 outline-none border border-gray-600"
                              title="Obdobje popravka OSS (YYYY-Qn)"
                            />
                          )}
                        </div>
                        {/* [PATCH oss-temelji v1] C1: podjetje brez nastavljenih
                            drzav -- izbirnik je prazen, zato povemo, kam iti. */}
                        {ossKontiNalozeni && !Object.keys(ossKonti).length && (
                          <div className="text-[10px] text-red-400">
                            Dodaj države v Nastavitve → Izdani računi → OSS države.
                          </div>
                        )}
                        {!ossStopnjaVeljavna(v) && (
                          <div className="text-[10px] text-red-400">
                            {v.drzava_potrosnje
                              ? `Stopnja ni veljavna za ${v.drzava_potrosnje} na ta datum.`
                              : 'Izberi dr\u017eavo potro\u0161nje.'}
                          </div>
                        )}
                        {/* [PATCH oss-temelji v1] 2e: knjizb prihodkov je vec
                            (ali nobene) -- uparjanje z OSS vrstico ni enolicno,
                            zato konta ne zamenjamo samodejno, ampak povemo,
                            kateri konto je nastavljen. */}
                        {ossPrihodkiDvoumni() && (
                          <div className="text-[10px] text-amber-400">
                            {'Konto prihodkov iz nastavitev za '}{ossPrihodkiDvoumni()}
                            {'. Knji\u017eb prihodkov je ve\u010d, zato ga vpi\u0161i ro\u010dno.'}
                          </div>
                        )}
                        {ossOpozoriloKonta(v) && (
                          <div className="text-[10px] text-amber-400">{ossOpozoriloKonta(v)}</div>
                        )}
                      </div>
                    )}
                  </td>
                  <td className="px-2 py-1.5 text-right">
                    <ZnesekInput
                      tabIndex={tabVnos ? -1 : undefined}
                      value={Number(v.osnova||0)}
                      /* [PATCH oss-temelji v1] B3: preracun DDV po stopnji je
                         tu veljal ze prej in velja tudi za OSS vrstice --
                         stopnja OSS vrstice je prava stopnja drzave potrosnje. */
                      onChange={n => updateVrstica(i, { osnova: n, znesek_ddv: Number((n * Number(v.stopnja || 0) / 100).toFixed(2)) })}
                      className="w-24"
                    />
                  </td>
                  <td className="px-2 py-1.5 text-right">
                    <ZnesekInput
                      tabIndex={tabVnos ? -1 : undefined}
                      value={Number(v.znesek_ddv||0)}
                      onChange={n => updateVrstica(i, { znesek_ddv: n })}
                      className="w-20"
                    />
                  </td>
                  <td className="px-2 py-1.5 text-center">
                    <input tabIndex={tabVnos ? -1 : undefined} type="checkbox" checked={v.odbitno}
                      onChange={e => updateVrstica(i, { odbitno: e.target.checked })}
                      className="w-3 h-3 accent-blue-500" />
                  </td>
                  <td className="px-2 py-1.5 text-center">
                    <input tabIndex={tabVnos ? -1 : undefined} type="checkbox" checked={v.popravek || false}
                      onChange={e => updateVrstica(i, { popravek: e.target.checked })}
                      className="w-3 h-3 accent-amber-500" />
                  </td>
                  <td className="px-2 py-1.5">
                    {v.popravek && (
                      <input
                        value={v.popravek_obdobje || ''}
                        onChange={e => updateVrstica(i, { popravek_obdobje: e.target.value })}
                        placeholder="npr. 3.2026"
                        className="w-20 bg-gray-800 text-white text-xs rounded px-1 py-0.5 outline-none border border-amber-500"
                      />
                    )}
                  </td>
                  <td className="px-1 py-1.5 text-center">
                    {vrstice.length > 1 && (
                      <button tabIndex={tabVnos ? -1 : undefined} onClick={() => odstraniVrstico(i)} className="text-red-400 hover:text-red-300 text-xs">&times;</button>
                    )}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td colSpan={7} className="px-2 py-1">
                <button tabIndex={tabVnos ? -1 : undefined} onClick={() => dodajVrstico(sk.knjiga)}
                  className="text-xs text-blue-400 hover:text-blue-300">+ Dodaj vrstico</button>
              </td>
            </tr>
          </tbody>
        ))}
        <tfoot className="bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
          <tr>
            <td className="px-2 py-1.5">
              {!vseKnjigeZasedene && (
                <button tabIndex={tabVnos ? -1 : undefined} onClick={dodajKnjigo}
                  title="Racun z vec vrstami prometa: doda novo knjigo (domaca / EU / uvoz)"
                  className="text-xs text-blue-400 hover:text-blue-300">+ Dodaj knjigo</button>
              )}
            </td>
            <td className="px-2 py-1.5 text-right font-mono font-bold text-gray-700 dark:text-gray-300">{fmt3(skupajOsnova)}</td>
            <td className={`px-2 py-1.5 text-right font-mono font-bold ${ddvNeujemanje ? 'text-red-600 dark:text-red-400' : 'text-gray-700 dark:text-gray-300'}`} title={ddvNaslov}>
              {/* [PATCH ddv-vsota-kontrola v1] neto se izpise VEDNO */}
              <div>{fmt3(skupajDdv)}</div>
              <div className="text-[10px] font-normal opacity-70">neto {fmt3(netoDdv)}</div>
            </td>
            <td colSpan={4}></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
